import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  autocompleteWrapper: {
    width: "100%",
    maxWidth: "400px",
    position: "relative",
  },
  search: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      maxWidth: "100%",
    },
  },
  profileAvatar: {
    alignSelf: "center",
    minWidth: "40px",
    minHeight: "40px",
    color: colors.mediumGrey,
    fontSize: "16px",
    fontWeight:"500",
    lineHeight:"24px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "4px",
    "& span": {
      color: colors.white
    }
  },
  removableChip: {
    display: "flex",
    padding: "0 0 0 16px",
    alignContent: "center",
  },
  allUsers: {
    padding: "10px",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    lineHeight: "20px",
    color: colors.mediumGrey,
    marginTop: "5px !important",
    marginBottom: "-3px !important",
    marginLeft: "5px !important"
  },
  removableChipContent: {
    display: "flex",
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: "6px",
    padding: "4px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey
  },
  removeBtn: {
    color: "red",
    "& svg": {
      cursor: "pointer",
      width: "17px",
      height: "17px",
      marginLeft: "5px",
      marginBottom: "3px"
    },
  },
  options: {
    position: "absolute",
    top: 48,
    background: colors.white,
    border: "1px solid " + colors.lightGrey,
    borderRadius: "8px",
    width: "100%",
    zIndex: 2,
    padding: "16px 14px 18px 14px",
    color: colors.mediumGrey,
    maxHeight: "230px",
    overflowY: "auto",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflowX: "hidden",
    "& p": {
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "400",
      padding: "8px",
      minHeight: "44px",
      margin: 0,
      wordWrap: "wrap"
    },
    "& ul": {
      margin: "-8px -6px -8px -6px",
      padding: "0px",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      listStyleType: "none",
      padding: 0,
      minHeight: "44px",
      fontSize: "16px",
      fontWeight: "500",
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        background: colors.brightBlue,
      },
      "& a": {
        width: "100%",
        padding: "14px 12px",
      }
    }
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
  },
  companyName: {
    fontSize: "16px",
    lineHeight: "24px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  profile: {
    display: "flex",
    justifyContent: "center",
    "& svg": {
      overflow: "initial"
    }
  },
  profileDetails: {
    marginLeft: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden" ,
    textOverflow: "ellipsis"
  },
  name: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack,
    margin: 0,
    padding: "0px !important",
    minHeight: "auto !important",
  },
  email: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.mediumGrey,
    padding: "0px !important",
    minHeight: "auto !important",
    whiteSpace: "nowrap",
    overflow: "hidden" ,
    textOverflow: "ellipsis",
    display: "contents !important"
  },
  detailedList: {
    cursor: "pointer",
  },
  accountNumber: {
    color: colors.mediumGrey,
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px"
  },
  clearBtn: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate( 0%, -50%)",
    cursor: "pointer"
  },
  clearBtnIcon: {
    marginRight: "14px",
    height: "20px",
    width: "20px",
    "& path": {
      stroke: colors.inactiveGrey
    }
  },
  policyWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  policyLocationWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginLeft: "14px"
  },
  policyBox: {
    display: "flex",
    justifyContent: "space-between"
  },
  companyDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flexBasis: "100%",
    marginTop: "4px",
    fontSize: "12px",
    color: colors.mediumGrey,
  },
  personInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  personEmail: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.mediumGrey,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  spinnerItem: {
    justifyContent: "center",
  },
  invitesSpinner: {
    display: "flex",
    justifyContent: "center",
    padding: "8px 0",
  },
}))

export default styles;
